import connection from '../connection';

export const getLeagueDivisions = async leagueId =>
   connection.get('v1/leagues/league_divisions', {league_id: leagueId});

export const getActivePadelboxEditions = async =>
   connection.get('v1/leagues/other_padelbox_leagues.json');

export const searchUser = async (email) =>
   connection.get('v1/leagues/search_user', {email});

export const hasDuplicateEnrollment = async (email, LeagueId, leagueCategoryId) =>
   connection.get('v1/leagues/has_duplicate_enrollment', {user_email: email, league_id: LeagueId, league_category_id: leagueCategoryId});

export const getLeagueDetails = async leagueId =>
   connection.get(`v1/leagues/league_details?id=${leagueId}`);

